
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { useEffect, useState } from "react";
import * as yup from 'yup';
import { useFormik } from "formik";
import { BackButton, CancelButton, SubmitButton } from "../../../../Components/Utils/Buttons";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import { NuDate, NuInput, NuTextArea } from "../../../../Components/Utils/Input";
import useEditFormData from "../../../../Components/Hooks/useEditFormData";
import UseCustomerDropDownNew from "../../../../Components/Hooks/useCustomerSearch";
import UseInspectorDD from "../../../../Components/Hooks/useInspectorSearch";
import DropDownAddMetaData from "../../../../Components/Utils/selectAddMetaData";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import Attachement, { videotype } from "../../../../Components/Utils/CustomAttrachmentupload";
import CloseIcon from "../../../../Components/Icons/Close";
import Video from "../../../../Components/Icons/Video";
import Doc from "../../../../Components/Icons/Doc";
import Xls from "../../../../Components/Icons/Xls";
import Txt from "../../../../Components/Icons/Txt";
import Pdf from "../../../../Components/Icons/Pdf";
import { useToast } from "../../../../Components/Others/ToastServices";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import UseDropDown from "../../../../Components/Hooks/useDropDown";
import MultiSelect from "../../../../Components/Utils/MultiSelect";
import axiosInstance from "../../../../Services/axiosCommon";

function EditSurveyReport() {
 
    const [searchClient, setSearchClient] = useState("");
    const [filePathList, setFilePathList] = useState([]);
    const [fileRemoveList, setFileRemoveList] = useState([]);
    const [image, setImage] = useState([]);
            const toast = useToast();
    const [selectedFile, setSelectedFile] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
        const [selectedImage, setSelectedImage] = useState(null);
        const [fileExtention, setFileExtention] = useState("");
    const { data: client, setDataCustomer } = UseCustomerDropDownNew(
      "/clients/drop-down",
      searchClient
    );
    const { data: inspector, setDataInspector } = UseInspectorDD(
      "/inspectors/drop-down",
      searchClient
    );
    const { value: status, getData: refStatus } = useFetchMataData(
      `/dropdown/dropdown-details/`,
      "Status_Survey"
    );

       const { data: user } = UseDropDown(`/user/drop-down`);
    
    const [showPopup, setShowPopup] = useState(false);
    const location = useLocation();
  
    
    const from = location.state.from;
    const sData = location.state?.data;
       
    const [data,setData] = useState(sData? sData:null);   
    const { surveyReportEditId } = useParams();
    const [removefilePathList, setRemoveFilePathList] = useState([]);
      

const togglePopup = () => {
 setShowPopup(!showPopup);
};
  const navigate = useNavigate();
    // const data = location.state.data;
    

  const {  editFormData } =
    useEditFormData
    (); 
     const [createNew, setCreateNew] = useState({
     
    clientId: data?.clientId  || "",
    project: data?.project  || "",
    scope: data?.scope  || "",
    location: data?.location  || "",
    inspector: data?.inspector  || "",
    status: data?.status  || "",
    inspectionDate: data?.inspectionDate  || "",
    // assignee: data?.assignee  || "",
    assignee: data?.assignee
    ? Array.from(new Set(data.assignee.map(item => item.assignee)))
    : []

    
  });

   
    
      function getView() {
        axiosInstance 
          .get(`/survey-report/getById/${surveyReportEditId}`)
          .then((res) => {
            setCreateNew(res.data?.data);       
          })
          .catch(err=>{
            console.log("err", err);
          })
      }
      
      useEffect(() => {
        if (!sData) {
          getView();
        }
      }, [surveyReportEditId])

  const removeImages = (value) => {
    console.log("value", value);
    let List = selectedFile.filter((item) => item?.name !== value);
    console.log("LIst", List);
    setSelectedFile([...List]);
    let tempArr = [];
    List.map((item) => {
      console.log("filestoremo",item);
      
      let fileName = item?.name;
      // console.log('fname',fileName);
      // let fileExtention =  fileName.split(".").reverse()[0]
      // if(filetype?.includes(fileExtention)){
      tempArr.push(fileName);
      // }else{
      //   let x = URL.createObjectURL(item)
      //   tempArr.push(x)
      // }
    });
    setImage(tempArr);
  };
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
       clientId: yup.string().required("Client is required!"),
                    // inspector: yup
                    //   .string()
                    //   .required("Inspector is required!"),
                                                         assignee: yup.array().required("Assigned To is required!"),
                                      
                      
          }),
          onSubmit: async (value, { resetForm }) => {
            let formData = new FormData();
            const valueWithItems = {
              ...value,
             
              filesToRemove: fileRemoveList,
            };
            formData.append("json_data", JSON.stringify(valueWithItems));
            if (selectedFile !== null) {
              selectedFile.forEach((file) => {
                formData.append("attachments", file);
              });
            } else {
              formData.append("attachments", []);
            }
            editFormData(
              `/survey-report/update_survey-report/${data?.id}`,
              formData,
              resetForm,
              from,
            );},
  });
  function handleImageChange(e) {
    const maxFileSize = 200000000; // 200 MB
    const files = Array.from(e.target.files);
    let fileArr = [];
    files.map((item) => {
      if (item.size < maxFileSize) {
        fileArr.push(item);
      } else {
        toast.open({
          type: "warning",
          message: `File Size to big`,
          description: `${item.name} is Removed and not Uploaded`,
          // placement: "bottomRight",
        });
      }
    });
    let tempArr = [];
    setSelectedFile(fileArr);
    files.map((item) => {
      if (item.size < maxFileSize) {
        let fileName = item?.name;
        console.log("fname", fileName);
        // let fileExtention = fileName.split(".").reverse()[0];
        // if (filetype?.includes(fileExtention)) {
        tempArr.push(fileName);
        // } else {
        //   let x = URL.createObjectURL(item);
        //   tempArr.push(x);
        // }
      }
    });
    console.log(tempArr, "temp");
    setImage(tempArr);
  }

   useEffect(() => {
          if (
            data?.attachments !== null &&
            data?.attachments !== "None" &&
            data?.attachments !== "[]"
          ) {
            // console.log(data.attachments, "ghjkllgd");
            setFilePathList(data?.attachments);
      
            setRemoveFilePathList(data?.attachments);
          }
        }, [data]);
  function UpdateAttachmentList(item) {
    let filterList = filePathList.filter((itemList) => itemList.file !== item);
    let removeFile = filePathList.find((itemList) => itemList.file === item);
    console.log("llll", filterList);
    setFileRemoveList([...fileRemoveList, removeFile.file]);
    setFilePathList(filterList);
   
  }
  function handleImageClick(img) {
    let Ext = img?.file_name.split(".").reverse()[0];
    setSelectedImage(img);
    setFileExtention(Ext);
    setIsModalOpen(true);
  }
 
 

  return (
    <div className=" w-full h-full py-2 px-4 ">
         <div className="flex justify-between w-full ">
            <Breadcrumb
                              items={[
                     
                                
                                {
                                  name: "Survey",
                                  link:"/client-management/survey-report"
                                 
                                },
                    
                                { name: "Edit" },
                              ]}
                            />        
        <BackButton />
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="w-full mx-auto h-[calc(100vh-145px)] bg-white rounded-xl overflow-hidden mt-4">
        <div className=" w-full h-full flex justify-start content-start flex-wrap py-2 px-4  overflow-y-auto">
            <div className="w-full">
              <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                Survey :
              </p>
            </div>
            <FormikSelectTwo
                             type="text"
                             label="Client "
                             placeholder="Client  "
                             Options={client}
                             formik={formik}
                             name="clientId"
                             isRequired={true}
                            width="w-full md:w-1/3 md:-mt-2"
                             
                             handleClick={togglePopup}
                             FixPosition={false}
                             PortalTarget={true}
                             
                             setSearch={setSearchClient}
                           />
            <NuInput
              type="text"
              label="Project"
              placeholder="Project"
              formik={formik}
              name="project"
              width="w-full md:w-1/3 md:-mt-2"
            />
               {/* <NuInput
              type="text"
              label="Scope"
              placeholder="scope"
              formik={formik}
              name="scope"
              width="w-full md:w-1/3 md:-mt-2"
            /> */}
            {/* <FormikSelectTwo
                             type="text"
                             label="Inspector"
                             placeholder="Inspector"
                             Options={inspector}
                             formik={formik}
                             name="inspector"
                             isRequired={true}
                            width="w-full md:w-1/3 md:-mt-2"
                             
                             handleClick={togglePopup}
                             FixPosition={false}
                             PortalTarget={false}
                             
                             setSearch={setSearchClient}
                           /> */}


<MultiSelect
              label="Assignee"
              Options={user}
              formik={formik}
              placeholder="Choose"
              name="assignee"
              isRequired={true}

              width="w-full md:w-1/3 md:-mt-2"
            />
               <NuInput
              type="text"
              label="Location"
              placeholder="Location"
              formik={formik}
              name="location"
              width="w-full md:w-1/3 md:-mt-2"
            />
           
           
           
            <NuDate
              label="Inspection Date"
              placeholder="Inspection Date"
              formik={formik}
              name="inspectionDate"
             
              width="w-full md:w-1/3 md:-mt-2"
            />
           
           
           <DropDownAddMetaData
                type="text"
                label="Status"
                placeholder="Status"
                Options={status}
                formik={formik}
                name="status"
                width="w-full md:w-1/2 lg:w-1/3 md:-mt-3"
                displayProperty={"Status"}
              propertyName={"Status_Survey"}
              getFunc={refStatus}

                
              />
           
           <NuTextArea
              type="text"
              label="Scope of Work"
              placeholder="Scope of Work"
              formik={formik}
              name="scope"
              width="w-full md:w-1/2 md:-mt-2"
            />
             <div className="w-full">
                <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-[#3369ff] decoration-2 underline-offset-4">
                   Attachement :
                </p>
                <Attachement
                    handleChange={handleImageChange}
                    preview={image || ""}
                    width="w-full md:w-1/2"
                    label="Attach"
                    multiple={true}
                removeImages={removeImages}

                  />
              </div>
              <div className="md:flex justify-between mt-5 px-3 w-full">
                <div className="w-full flex gap-2 items-center flex-wrap">
                  {data?.attachments &&
                    filePathList?.map((imgs, idx) => {
                      console.log("img", imgs);
                      let Ext = imgs?.file_name.split(".").reverse()[0];
                      return (
                        <div
                          className=" w-20 h-9 my-2 relative flex justify-center items-center rounded-lg"
                          key={idx}
                          style={{
                            border: "1px solid gray",
                            borderColor:
                              "rgb(148 163 184 / var(--tw-bg-opacity))",
                          }}
                        >
                          <div
                            className=" w-4 h-4 rounded bg-slate-400 absolute text-white cursor-pointer font-medium flex justify-center items-center  -top-2 -right-2 z-10"
                            onClick={() => UpdateAttachmentList(imgs?.file)}
                          >
                            <CloseIcon color="white" height="8" width="8" />
                          </div>
                          <div
                            className=" w-20 h-9 flex justify-center items-center rounded-lg overflow-hidden cursor-pointer"
                            onClick={() => handleImageClick(imgs)}
                          >
                            <div className=" w-8 h-8">
                              {videotype.includes(Ext) ? <Video /> : null}

                              {Ext === ("docx" || "doc" || "txt") ? (
                                <Doc />
                              ) : Ext === ("xlsx" || "xls") ? (
                                <Xls />
                              ) : Ext === "txt" ? (
                                <Txt />
                              ) : Ext === "pdf" ? (
                                <Pdf />
                              ) : Ext === "PDF" ? (
                                <Pdf />
                              ) : Ext === "pptx" ? (
                                <>No file</>
                              ) : (
                                <img src={imgs?.file} alt="#" width="120%" />
                              )}
                            </div>
                            <p className=" w-[50px] text-[11px] truncate">
                              {imgs?.file_name}
                            </p>
                          </div>
                        </div>
                      );
                    })}

                  
                </div>
              </div>
            <div className="w-full  my-4 mt-8 ">
              <div className=" flex justify-end gap-4">
                <CancelButton
                  handleClick={() => {
                    navigate(-1);
                  }}
                />
                <SubmitButton />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default EditSurveyReport